import extendNode from '../extendNode.mjs'
import Color from '../Color.mjs'
import useProductNode from '../_PRODUCT/useProductNode.jsx'
import IconLetters from '../icons/IconLetters.jsx'
import meta from './metaMid.mjs'
import Model from './ModelMid.mjs'
import PropertiesPane from './PropertiesPaneMid.jsx'
import FormChoose from './FormChooseMid.jsx'
import TableChoose from './TableChooseMid.jsx'
import api from './apiMid.mjs'

export default () => {
    const ProductNode = useProductNode()

    return extendNode(ProductNode, {
        ...meta,
        api,
        FormChoose,
        TableChoose,
        Model,
        PropertiesPane,

        getIcons() {
            return [
                <IconLetters
                    key="type"
                    fill={Color.DARK_GOLD}
                    letters="M"
                    textColor="#fff"
                />
            ]
        },

        _pushDataSlots: {
            archMiddlewareInss: [],
        },

        _getCategories(map, node) {
            return [
                'MID_MIDINS',
            ]
        },

        _getThemeColor(map, node) {
            return Color.GREEN_YELLOW
        },

        async _grow(map, node, depth) {
            const newDepth = await ProductNode._grow.call(
                this, map, node, depth
            )

            if (newDepth === depth) {
                return depth
            }

            const p = node.trueParent

            if (p) {
                const {bizNodeType} = p.data

                if (/^(SS_MID|DEP_MID)$/.test(bizNodeType)) {
                    for (const n of [...node.children]) {
                        if ('MID_MIDINS' === n.data.bizNodeType) {
                            map.deleteNode(n)
                        }
                        else {
                            map.deleteTree(n)
                        }
                    }
                }
            }

            return newDepth
        },
    })
}
